import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {timer as observableTimer,  Subscription ,  Observable } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-success-modal',
  imports: [TranslatePipe,FormsModule,CommonModule],
  templateUrl: './success-modal.html',
  styleUrl: './success-modal.scss',
})
export class SuccessModal {
  @Output() showHideSuccessModal = new EventEmitter<any>();
  @Input() message:any;

  showResetApproval: boolean = false;
  public showloader: boolean = false;
  private subscription: Subscription = Subscription.EMPTY;
  private timer: Observable<any> = new Observable();
  constructor() { }

  ngOnInit() {
    this.setTimer();
  }
  public closeModal = () => {
    if (this.showResetApproval) {
      this.showResetApproval = false;
      return;
    }
    this.showHideSuccessModal.emit(false);
  }
  public ngOnDestroy() {
    if (this.subscription && this.subscription instanceof Subscription) {
      this.subscription.unsubscribe();
    }
  }
  public setTimer() {
    // set showloader to true to show loading div on view

    this.timer = observableTimer(2000); // 1000 millisecond means 1 seconds
    this.subscription = this.timer.subscribe(() => {
      this.closeModal();
    });
  }
}
